import { Box, ColorOptions, ModBox, RadioButtonGroup, Spacer, Text, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { useEffect, useState } from 'react'
import { Dropdown } from '../../components/Dropdown'
import { VpaList } from '../../components/VpaList'
import { useStores } from '../../data/store'
import { isValidUrl } from '../../utils/constants'
import { SelectParentEntityList } from '../EntityManagement/Onboarding/CreateEntity/SelectParentEntityList'
import { ConfigItem } from './ConfigItem'
import { ConfigList } from './ConfigList'
const tableHeaderTitles = [
  {
    title: 'URL Type',
  },
  {
    title: 'S2S URL',
  },
  {
    title: '',
  },
]

const tableColumnMapper = {
  0: 1,
  1: 1.5,
  2: 0.5,
}

const channelIdsColumnFlex = {
  0: 1,
  1: 1,
}

const nonEditColumsFlex = [
  {
    1: 1,
  },
]

const channelIdTitles = [
  {
    title: 'Allowed Channel Ids',
  },
  {
    title: 'Action',
  },
]

const nonEditTitles = [
  {
    title: 'Allowed Channel Ids',
  },
]

// const getConfigTypeKeyValue = (type: string) => {}

const radiobtnsListArray = (getValueFromConfigurations: any) => {
  return [
    {
      type: 'INTEGRATION_TYPE',
      id: '1',
      title: 'Integration Type',
      rbData: ['PCI', 'NON_PCI'],
      key: 'PCI',
      value:
        getValueFromConfigurations('PCI', 'INTEGRATION_TYPE') === 'Y'
          ? 'PCI'
          : getValueFromConfigurations('PCI', 'INTEGRATION_TYPE') === 'N'
          ? 'NON_PCI'
          : 'NA',
    },
    //PAYMENT_ACCEPTANCE	613 sodexo
    {
      type: 'PAYMENT_ACCEPTANCE',
      id: '2',
      title: 'Sodexo',
      rbData: ['Yes', 'No'],
      key: '613',
      value:
        getValueFromConfigurations('613', 'PAYMENT_ACCEPTANCE') === 'Y'
          ? 'Yes'
          : getValueFromConfigurations('613', 'PAYMENT_ACCEPTANCE') === 'N'
          ? 'No'
          : 'NA',
    },
    //OFFER_APPLICABLE	MERCHANT_OFFER
    {
      type: 'OFFER_APPLICABLE',
      id: '3',
      title: 'Offers',
      rbData: ['Yes', 'No'],
      key: 'MERCHANT_OFFER',
      value:
        getValueFromConfigurations('MERCHANT_OFFER', 'OFFER_APPLICABLE') === 'Y'
          ? 'Yes'
          : getValueFromConfigurations('MERCHANT_OFFER', 'OFFER_APPLICABLE') === 'N'
          ? 'No'
          : 'NA',
    },
    // {
    //   type: 'subscriptions', //TODO: change
    //   id: '4',
    //   title: 'Subscription',
    //   rbData: ['Yes', 'No'],
    //   key: 'SUBCRIPTION_KEY', //TODO: change
    //   value:
    //     getValueFromConfigurations('subscriptions', '') === 'Y'
    //       ? 'Yes'
    //       : getValueFromConfigurations('subscriptions', '') === 'N'
    //       ? 'No'
    //       : 'NA',
    // },
    //ALLOWED_TXN_TYPE	114	Allowed EMI Transaction
    {
      type: 'ALLOWED_TXN_TYPE',
      id: '5',
      title: 'EMI Flag',
      rbData: ['Yes', 'No'],
      key: '114',
      value:
        getValueFromConfigurations('114', 'ALLOWED_TXN_TYPE') === 'Y'
          ? 'Yes'
          : getValueFromConfigurations('114', 'ALLOWED_TXN_TYPE') === 'N'
          ? 'No'
          : 'NA',
    },
    //SUPER_MERCHANT	TOKENISATION_MID	Tokenization MID for Merchants
    {
      type: 'SUPER_MERCHANT',
      id: '6',
      title: 'Tokenization Flag',
      rbData: ['Yes', 'No'],
      key: 'TOKENISATION_MID',
      value:
        getValueFromConfigurations('TOKENISATION_MID', 'SUPER_MERCHANT') === 'Y'
          ? 'Yes'
          : getValueFromConfigurations('TOKENISATION_MID', 'SUPER_MERCHANT') === 'N'
          ? 'No'
          : 'NA',
    },
    //PAYMENT_ACCEPTANCE	595	COLLECT_LINK_REQUEST
    {
      type: 'PAYMENT_ACCEPTANCE', //TODO: change
      id: '7',
      title: 'Collect Link',
      rbData: ['Yes', 'No'],
      key: '595', //TODO: change
      value:
        getValueFromConfigurations('595', 'PAYMENT_ACCEPTANCE') === 'Y'
          ? 'Yes'
          : getValueFromConfigurations('595', 'PAYMENT_ACCEPTANCE') === 'N'
          ? 'No'
          : 'NA',
    },
    {
      type: 'ALLOWED_TXN_TYPE', //TODO: change
      id: '8',
      title: 'Issue Refund',
      rbData: ['Yes', 'No'],
      key: '212', //TODO: change
      value:
        getValueFromConfigurations('212', 'ALLOWED_TXN_TYPE') === 'Y'
          ? 'Yes'
          : getValueFromConfigurations('212', 'ALLOWED_TXN_TYPE') === 'N'
          ? 'No'
          : 'NA',
    },
  ]
}

const convienienceFeeRadioBtn = (getValueFromConfigurations: any) => {
  //MERCHANT_CONVENIENCE_FEE	CONVENIENCE_FEE	Flag to determine if convenience fee is enabled (1) or disabled (0)
  return {
    type: 'MERCHANT_CONVENIENCE_FEE',
    id: '8',
    title: 'Convienience Fee',
    rbData: ['Yes', 'No'],
    key: 'CONVENIENCE_FEE', //TODO: change
    value:
      getValueFromConfigurations('CONVENIENCE_FEE', 'MERCHANT_CONVENIENCE_FEE') === '1'
        ? 'Yes'
        : getValueFromConfigurations('CONVENIENCE_FEE', 'MERCHANT_CONVENIENCE_FEE') === '0'
        ? 'No'
        : 'NA',
  }
}

const convienienceFeeRadioBtnsArr = (getValueFromConfigurations: any) => {
  //MERCHANT_CONVENIENCE_FEE	CONVENIENCE_MODEL	Flag to determine if convenience model is to settle NetAmount or GrossAmount to merchant
  return [
    {
      type: 'MERCHANT_CONVENIENCE_FEE',
      id: '9',
      title: 'Convienience Model',
      rbData: ['Gross', 'Net'],
      key: 'CONVENIENCE_MODEL', //TODO: change
      value:
        getValueFromConfigurations('CONVENIENCE_MODEL', 'MERCHANT_CONVENIENCE_FEE') === '1'
          ? 'Gross'
          : getValueFromConfigurations('CONVENIENCE_MODEL', 'MERCHANT_CONVENIENCE_FEE') === '0'
          ? 'Net'
          : 'NA',
    },
    //MERCHANT_CONVENIENCE_FEE	REFUND_TYPE	Flag to determine if convenience fee refund type is set to NetAmount or GrossAmount
    {
      type: 'MERCHANT_CONVENIENCE_FEE',
      id: '10',
      title: 'Refund Type',
      rbData: ['Gross', 'Net'],
      key: 'REFUND_TYPE',
      value:
        getValueFromConfigurations('REFUND_TYPE', 'MERCHANT_CONVENIENCE_FEE') === '1'
          ? 'Gross'
          : getValueFromConfigurations('REFUND_TYPE', 'MERCHANT_CONVENIENCE_FEE') === '0'
          ? 'Net'
          : 'NA',
    },
  ]
}

const s2sUrlDropDownData = [
  { id: '1', value: 'Create Mandate' },
  { id: '2', value: 'PreProcess' },
  { id: '3', value: 'EMI' },
  { id: '4', value: 'Payment Intent' },
  { id: '5', value: 'Refund' },
  { id: '6', value: 'URL for Purchase' },
  { id: '7', value: 'General Callback' },
]

const collectLinkDropDownData = [
  { id: '1', value: 'Terms & Conditions' },
  { id: '2', value: 'About Us' },
  { id: '3', value: 'Contact Us' },
  { id: '4', value: 'Privacy Policy' },
  { id: '5', value: 'Refund Cancellation Policy' },
]
const ListItem = ({ data }: any) => {
  return (
    <Box marginRight={16} pv={8} f={1}>
      <Text title={data.key} color={'PRIMARY_GREY'} fontSize={12} fontFamily={'jiotype-medium'} lineHeight={18} />
      <Text title={data.value} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-medium'} lineHeight={20} />
    </Box>
  )
}

const RadioButtonListItem = ({ data, updateGeneralConfigs, isEdit }: any) => {
  const handleOnChange = (isChecked: any) => {
    if (isChecked !== 'NA') {
      updateGeneralConfigs(
        data.type,
        data?.key,
        isChecked === 'NON_PCI'
          ? 'N'
          : isChecked === 'PCI'
          ? 'Y'
          : isChecked === 'Yes' &&
            data?.key !== 'CONVENIENCE_FEE' &&
            data?.key !== 'CONVENIENCE_MODEL' &&
            data?.key !== 'REFUND_TYPE'
          ? 'Y'
          : isChecked === 'Net'
          ? '0'
          : isChecked === 'Gross'
          ? '1'
          : isChecked === 'Yes' &&
            (data?.key === 'CONVENIENCE_FEE' || data?.key === 'CONVENIENCE_MODEL' || data?.key === 'REFUND_TYPE')
          ? '1'
          : isChecked === 'No' &&
            (data?.key === 'CONVENIENCE_FEE' || data?.key === 'CONVENIENCE_MODEL' || data?.key === 'REFUND_TYPE')
          ? '0'
          : 'N',
      )
    }
  }
  return (
    <Box pv={8} marginRight={8} minWidth={180}>
      <Text title={data.title} color={'PRIMARY_GREY'} fontSize={12} fontFamily={'jiotype-medium'} lineHeight={18} />
      <ModBox show={isEdit}>
        <RadioButtonGroup
          data={data.rbData}
          textSize={12}
          size={12}
          textPadding={0}
          minItemHeight={36}
          horizontalGap={2}
          direction={'horizontal'}
          onChange={handleOnChange}
          value={data?.value}
          callOnChangeOnLoad={false}
        />
      </ModBox>
      <ModBox show={!isEdit}>
        <Text title={data?.value} color={'BLACK'} fontSize={12} fontFamily={'jiotype-medium'} lineHeight={18} />
      </ModBox>
    </Box>
  )
}

interface props {
  isOnboarding: boolean
  selectedEntity?: any
  type?: string
}
const GeneralConfig = ({ isOnboarding, selectedEntity, type }: props) => {
  const {
    listData,
    updateGeneralConfigs,
    mid,
    aesKey,
    macKey,
    addUrls,
    addChannelIds,
    getUrlsFromType,
    getTableChannelIds,
    convienienceFee,
    isCollectLinkTypeAdded,
    isS2STypeAdded,
    deleteUrlByType,
    isChannelIdAdded,
    getMerchantQrByVpas,
    getVpasToFetchUrls,
    getTidVpaList,
    getIndividualConfigValueFromKey,
    isEditMode,
    getValueFromConfigurations,
    getAddedUrls,
    addToCreateConfigurationsList,
    s2sUrlsLength,
    collectLinkUrlsLength,
    getOtherConfigs,
    configurationsList,
  } = useStores((store) => ({
    listData: store.onboarding.getApiOnboardedData,
    updateGeneralConfigs: store.onboarding.updateGeneralConfigs,
    generateQrUrl: store.onboarding.generateQrUrl,
    mid: store.onboarding.mid,
    aesKey: store.onboarding.AES_KEY,
    macKey: store.onboarding.MAC_KEY,
    addUrls: store.onboarding.addUrls,
    addChannelIds: store.onboarding.addChannelIds,
    getUrlsFromType: store.onboarding.getUrlsFromType,
    getTableChannelIds: store.onboarding.getTableChannelIds,
    convienienceFee: store.onboarding.convienienceFee,
    isCollectLinkTypeAdded: store.onboarding.isCollectLinkTypeAdded,
    isS2STypeAdded: store.onboarding.isS2STypeAdded,
    deleteUrlByType: store.onboarding.deleteUrlByType,
    isChannelIdAdded: store.onboarding.isChannelIdAdded,
    channelIdsLength: store.onboarding.channelIds.length,
    collectLinkUrlsLength: store.onboarding.collectLinkUrls.length,
    s2sUrlsLength: store.onboarding.s2sUrls.length,
    getMerchantQrByVpas: store.onboarding.getMerchantQrByVpas,
    getVpasToFetchUrls: store.onboarding.getVpasToFetchUrls,
    getTidVpaList: store.onboarding.getTidVpaList,
    getIndividualConfigValueFromKey: store.onboarding.getIndividualConfigValueFromKey,
    isEditMode: store.onboarding.isEditMode,
    getValueFromConfigurations: store.onboarding.getValueFromConfigurations,
    getAddedUrls: store.onboarding.getAddedUrls,
    addToCreateConfigurationsList: store.onboarding.addToCreateConfigurationsList,
    getOtherConfigs: store.getOtherConfigs(),
    configurationsList: store.getConfigurationsList(),
  }))

  const [isConvenienceFeeEnabled, setConvFeeSelected] = useState(
    convienienceFeeRadioBtn(getValueFromConfigurations)?.value?.length > 0,
  )

  const [gstInvoiceTemplate, setGstInvoiceTemplate] = useState(
    getValueFromConfigurations('GST_INVOICE_TEMPLATE', 'MERCHANT_CONVENIENCE_FEE'),
  )
  const [s2sUrl, setS2SUrl] = useState('')
  const [collectLinkUrl, setCollectLinkUrl] = useState('')
  const [channelId, setChannelId] = useState('')

  const [s2sUrlType, setS2SUrlType] = useState('Create Mandate')
  const [collectLinkUrlType, setCollectLinkUrlType] = useState('Terms & Conditions')

  const handleChannelIdChange = (changedValue: string) => {
    if (/^\d+$/.test(changedValue) || changedValue === '') {
      setChannelId(changedValue)
    }
  }

  useEffect(() => {
    const vpas = getVpasToFetchUrls()
    if (vpas.length > 0) {
      getMerchantQrByVpas(mid, vpas)
    }
  }, [getMerchantQrByVpas, getVpasToFetchUrls, mid])

  const onAddCollectLinks = () => {
    if (!isCollectLinkTypeAdded(collectLinkUrlType) && collectLinkUrl.length > 0 && isValidUrl(collectLinkUrl)) {
      addUrls('collectLinkUrls', collectLinkUrlType, collectLinkUrl)
      setCollectLinkUrl('')
      setCollectLinkUrlType('Terms & Conditions')
    }
  }

  const onAddS2SUrl = () => {
    if (!isS2STypeAdded(s2sUrlType) && s2sUrl.length > 0 && isValidUrl(s2sUrl)) {
      addUrls('s2sUrls', s2sUrlType, s2sUrl)
      setS2SUrl('')
      setS2SUrlType('Create Mandate')
    }
  }

  const addChannelIdsToStore = () => {
    if (!isChannelIdAdded(channelId) && channelId.length > 0) {
      addChannelIds(channelId)
      setChannelId('')
    }
  }

  const onDeleteS2SUrl = (data: any) => {
    console.log('onDeleteS2SUrl: ', data?.type)
    deleteUrlByType('s2sUrls', data?.type)
  }

  const onDeleteCollectLinkUrl = (data: any) => {
    console.log('onDeleteCollectLinkUrl: ', data?.type)
    deleteUrlByType('collectLinkUrls', data?.type)
  }

  const onDeleteChannelId = (data: any) => {
    console.log('onDeleteChannelId: ', data?.id)
    deleteUrlByType('channelIds', data?.id)
  }

  const handleConvienienceSelection = (type: string, key: string, value: any) => {
    setConvFeeSelected(value === '1')
    addToCreateConfigurationsList(type, key, value)
  }

  const handleGstInvoiceChange = (value: string) => {
    setGstInvoiceTemplate(value)
    addToCreateConfigurationsList('MERCHANT_CONVENIENCE_FEE', 'GST_INVOICE_TEMPLATE', value)
  }
  return (
    <Box overflow={'auto'} ph={16} pv={32} h={'100%'}>
      <ModBox show={true}>
        <Text title={'General Configuration'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <Box flexDirection={'row'} flexWrap={'wrap'} pv={24}>
          {listData(selectedEntity?.id).map((item: any, index: number) => {
            return <ListItem data={item} key={index} />
          })}
        </Box>
        <ModBox show={false}>
          <VpaList data={getTidVpaList(selectedEntity?.id, type)} />
        </ModBox>
        <Spacer direction="vertical" size={32} />
        <TextInputNew
          editable={isEditMode}
          value={aesKey}
          {...styles.textinput(isEditMode)}
          label={'AES Key'}
          focusBorderColor={'DISABLED_GREY'}
          onChange={(val: any) => updateGeneralConfigs('AES_KEY', val)}
          paddingHorizontal={8}
        />
        <Spacer direction="vertical" size={32} />
        <TextInputNew
          editable={isEditMode}
          value={macKey}
          {...styles.textinput(isEditMode)}
          label={'MAC Key'}
          focusBorderColor={'DISABLED_GREY'}
          onChange={(val: any) => updateGeneralConfigs('MAC_KEY', val)}
          paddingHorizontal={8}
        />
        <Spacer direction="vertical" size={32} />
        <Box flexDirection={'row'} flexWrap={'wrap'} marginBottom={16}>
          {radiobtnsListArray(getValueFromConfigurations).map((item: any, index: number) => {
            return (
              <RadioButtonListItem
                data={item}
                updateGeneralConfigs={addToCreateConfigurationsList}
                isEdit={isEditMode}
                key={index}
              />
            )
          })}
        </Box>

        <Box w={'100%'} h={1} backgroundColor={'BORDER_COLOR'} />
        <Box marginTop={32} marginBottom={16}>
          <Text
            title={'Convienience Fee Configurations'}
            color={'BLACK_21'}
            fontSize={18}
            fontFamily={'jiotype-bold'}
          />
          <Box direction="row" marginTop={16} marginBottom={16}>
            <RadioButtonListItem
              data={convienienceFeeRadioBtn(getValueFromConfigurations)}
              updateGeneralConfigs={handleConvienienceSelection}
              isEdit={isEditMode}
            />
            <ModBox show={isConvenienceFeeEnabled} flexDirection={'row'} flexWrap={'wrap'}>
              {convienienceFeeRadioBtnsArr(getValueFromConfigurations).map((item: any, index: number) => {
                return (
                  <RadioButtonListItem
                    data={item}
                    updateGeneralConfigs={addToCreateConfigurationsList}
                    isEdit={isEditMode}
                    key={index}
                  />
                )
              })}
              <TextInputNew
                editable={isEditMode}
                value={gstInvoiceTemplate}
                {...styles.textinput(isEditMode)}
                label={'GST Invoice Template ID'}
                focusBorderColor={'DISABLED_GREY'}
                onChange={handleGstInvoiceChange}
                paddingHorizontal={8}
              />
            </ModBox>
          </Box>
        </Box>
        <Box w={'100%'} h={1} backgroundColor={'BORDER_COLOR'} />
        <Box marginVertical={32}>
          <Text title={'S2S URL Configurations'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          <Box direction="row" alignItems={'center'} marginTop={16}>
            <Dropdown
              data={s2sUrlDropDownData}
              label={'URL Type'}
              value={s2sUrlType}
              selectedData={(value) => setS2SUrlType(value)}
              selectable={isEditMode}
              chevronColor={isEditMode ? 'BLACK_75' : 'DISABLED_GREY'}
            />
            <Spacer direction="horizontal" size={16} />
            <TextInputNew
              editable={isEditMode}
              value={s2sUrl}
              {...styles.textinput(isEditMode)}
              label={'S2S URL'}
              focusBorderColor={'DISABLED_GREY'}
              onChange={(val: any) => setS2SUrl(val)}
              paddingHorizontal={8}
            />
            <Box marginTop={24} marginLeft={16}>
              <ButtonNew
                height={38}
                type={'secondary'}
                title={'+ ADD'}
                onPress={onAddS2SUrl}
                borderColor={'#0070B6'}
                disabled={!isEditMode}
              />
            </Box>
          </Box>
          <ModBox show={s2sUrlsLength > 0 || getUrlsFromType('s2sUrls', isEditMode).length > 0} marginTop={16}>
            <SelectParentEntityList
              title={''}
              hide={false}
              data={[...getUrlsFromType('s2sUrls', isEditMode), ...getAddedUrls('s2sUrls')] ?? []}
              columnFlexMapper={tableColumnMapper}
              headerTitles={tableHeaderTitles ?? []}
              onDelete={onDeleteS2SUrl}
            />
          </ModBox>
        </Box>
        <Box w={'100%'} h={1} backgroundColor={'BORDER_COLOR'} />
        <Box marginVertical={32}>
          <Text title={'Collect Link Configurations'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
          <Box direction="row" alignItems={'center'} marginTop={16}>
            <Dropdown
              data={collectLinkDropDownData}
              label={'URL Type'}
              value={collectLinkUrlType}
              selectedData={(value) => setCollectLinkUrlType(value)}
              selectable={isEditMode}
              chevronColor={isEditMode ? 'BLACK_75' : 'DISABLED_GREY'}
            />
            <Spacer direction="horizontal" size={16} />
            <TextInputNew
              editable={isEditMode}
              value={collectLinkUrl}
              {...styles.textinput(isEditMode)}
              label={'URL'}
              focusBorderColor={'DISABLED_GREY'}
              onChange={(val: any) => setCollectLinkUrl(val)}
              paddingHorizontal={8}
            />
            <Box marginTop={24} marginLeft={16}>
              <ButtonNew
                height={38}
                type={'secondary'}
                title={'+ ADD'}
                onPress={onAddCollectLinks}
                disabled={!isEditMode}
                borderColor={'#0070B6'}
              />
            </Box>
          </Box>
          <ModBox
            show={collectLinkUrlsLength > 0 || getUrlsFromType('collectLinkUrls', isEditMode).length > 0}
            marginTop={16}>
            <SelectParentEntityList
              title={''}
              hide={false}
              data={[...getUrlsFromType('collectLinkUrls', isEditMode), ...getAddedUrls('collectLinkUrls')] ?? []}
              columnFlexMapper={tableColumnMapper}
              headerTitles={tableHeaderTitles ?? []}
              onDelete={onDeleteCollectLinkUrl}
            />
          </ModBox>
        </Box>
        <Box w={'100%'} h={1} backgroundColor={'BORDER_COLOR'} />
      </ModBox>
      <Box marginVertical={16}>
        <Text title={'Channel ID Configuration'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <Box direction="row" alignItems={'center'} marginTop={16}>
          <TextInputNew
            editable={isEditMode}
            value={channelId}
            {...styles.textinput(isEditMode)}
            label={'Allowed Channel'}
            focusBorderColor={'DISABLED_GREY'}
            onChange={handleChannelIdChange}
            paddingHorizontal={8}
          />
          <Box marginTop={24} marginLeft={16} disabled={!isEditMode}>
            <ButtonNew
              height={38}
              type={'secondary'}
              title={'+ ADD'}
              onPress={addChannelIdsToStore}
              borderColor={'#0070B6'}
              disabled={!isEditMode}
            />
          </Box>
        </Box>
        <ModBox show={getTableChannelIds().length > 0} w={'50%'} marginTop={16}>
          <SelectParentEntityList
            title={''}
            hide={false}
            data={getTableChannelIds() ?? []}
            columnFlexMapper={isEditMode ? channelIdsColumnFlex : nonEditColumsFlex}
            headerTitles={isEditMode ? channelIdTitles : nonEditTitles}
            onDelete={onDeleteChannelId}
            isEditMode={isEditMode}
          />
        </ModBox>
      </Box>
      <ModBox w={'100%'} h={1} backgroundColor={'BORDER_COLOR'} show={getOtherConfigs?.length > 0} />
      <ModBox w={'100%'} marginTop={32} show={getOtherConfigs?.length > 0}>
        <Text title={'Others'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ModBox direction="row" w={'100%'} justifyContent={'space-between'} marginTop={16} flexWrap={'wrap'}>
          {getOtherConfigs?.length > 0 &&
            getOtherConfigs?.map((otherConfig) => {
              return (
                <ConfigItem
                  title={otherConfig?.configType}
                  key={otherConfig?.key}
                  value={otherConfig?.value}
                  status={otherConfig?.status ?? ''}
                  label={otherConfig?.key}
                  isEdit={false}
                />
              )
            })}
        </ModBox>
      </ModBox>
      <ModBox show={configurationsList?.length > 0}>
        <ConfigList configList={configurationsList} />
      </ModBox>
    </Box>
  )
}

const styles = {
  textinput: (isEditMode: boolean) =>
    ({
      type: 'body12',
      borderColor: '#d1d3e2' as ColorOptions,
      labelPaddingBottom: 10,
      borderRadius: 4,
      labelFontFamily: 'jiotype-bold',
      fontFamily: 'jiotype-medium',
      labelColor: isEditMode ? 'BLACK_21' : ('#616161' as ColorOptions),
      labelFontSize: 12,
      fontSize: 12,
      selectionColor: isEditMode ? 'BLUE' : 'TRANSPARENT',
      paddingVertical: 9,
      color: isEditMode ? 'BLACK_21' : ('#d1d3e2' as ColorOptions),
      onFocusBorderWidth: 1,
    } as unknown as TextInputNewProps),
}
export default GeneralConfig
